module.exports = __webpack_public_path__ + "media/categories/1029-9796b0c3.svg";